import { Navbar, Nav, Row, Col, Button, Overlay, Tooltip, Card, Dropdown, Badge, NavDropdown, Form, FormControl, Container } from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import Logo from '../../assets/images/favicon.png';
import GstrHeader from "../forms/headers/GstrHeader";
import MainHeader from "./MainHeader";
import { setNavOpen } from "../../slices/common";
import { clearUserData } from "../../slices/user";
import { useSelector, useDispatch } from "react-redux";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ResetPasswordModal from "./ResetPasswordModal";
import { setNotification, clearNotification, getNotifications, fetchNewNotifications } from '../../slices/notification';
import { toast } from "react-toastify";

const Header = (props) => {
    const { showLogo, type, headerTitle } = props;
    const [show, setShow] = useState(false);
    const target = useRef(null); // Ref to target the button for Overlay
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const navOpen = useSelector((state) => state.common.navOpen);
    const { userData } = useSelector((state) => state.user);
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
    const { notificationList, isNotificationRoute, notificationUrl, loading: NotificationLoading, latestNotificationId, newNotificationFound } = useSelector((state) => state.notification);
    const latestNotificationIdRef = useRef(latestNotificationId);
    const [current_page, setCurrentPage] = useState(1);
    const gstrHeaderAllowedTypes = ['gstr', 'refunds', 'gstr3b', 'gstr9', 'gstr9c', 'litigations', 'ExportImportFacilitation', 'gstRepo', "HSN/SAC"];
    // Toggle dropdown visibility
    const handleProfileToggle = (isOpen) => {
        setShowProfileDropdown(isOpen);
    };
    useEffect(() => {
        if (!showLogo) setShow(false);
    }, [showLogo])


    const handleSignOut = () => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        dispatch(clearUserData())
        navigate('/login')
    }

    const toggleSidebar = () => {
        document.body.classList.toggle('sidebar-main');
    }

    const handleResetPasswordModalClose = async () => {
        setShowResetPasswordModal(false);
    }

    useEffect(() => {
        if (isNotificationRoute) {
            navigate(notificationUrl);
        }

    }, [isNotificationRoute]);


    /*useEffect(() => {
    const interval = setInterval(() => {
        dispatch(fetchNewNotifications({latest_notification_id: latestNotificationIdRef.current, page: current_page}));
    }, 60000 * 1);
    return () => clearInterval(interval);
    }, [dispatch]);*/

    useEffect(() => {
        if (latestNotificationId)
            latestNotificationIdRef.current = latestNotificationId;
        if (newNotificationFound) {
            toast.success("New notification received!", {
                position: 'top-center'
            })
            dispatch(getNotifications({ page: current_page }));
        }
        dispatch(clearNotification());
    }, [latestNotificationId, newNotificationFound]);

    return (
        <>
            <div className="iq-top-navbar">
                <div className="iq-navbar-custom">
                    <Navbar expand="lg" className="navbar navbar-light p-0">
                        <div className="iq-navbar-logo d-flex align-items-center justify-content-between w-100 w-lg-auto">
                            <div className="d-flex align-items-center">
                                <i className="ri-menu-line wrapper-menu" onClick={toggleSidebar}></i>
                                <Nav.Link as={NavLink} to="/" className={`header-logo ml-2 ml-lg-0`}>
                                    <img src={Logo} className="  light-logo" alt="logo" style={{ maxHeight: '40px' }} />
                                    {/* <img src={LogoWhite} className="img-fluid rounded-normal darkmode-logo d-none" alt="logo" style={{ maxHeight: '40px' }} /> */}
                                </Nav.Link>
                            </div>

                            {/* Mobile navbar toggler */}
                            <Navbar.Toggle aria-controls="navbarSupportedContent" className="d-lg-none bg-primary">
                                <i className="ri-menu-3-line"></i>
                            </Navbar.Toggle>
                        </div>
                        <Col xs={12} lg={2} className="mt-1 ml-lg-2">
                            <h4 className="mb-0">{headerTitle ? headerTitle : ''}</h4>
                        </Col>

                        {/* Search/Header content area - responsive */}
                        <div className={`iq-search-bar device-search flex-grow-1 d-none d-lg-block ${showLogo || navOpen ? 'col-lg-7 col-xl-8' : 'col-lg-9'}`}>
                            {gstrHeaderAllowedTypes.includes(type) ? <GstrHeader headerTitle={headerTitle} type={type} /> : <MainHeader headerTitle={headerTitle} />}
                        </div>

                        {/* Navbar Collapse for mobile */}
                        <Navbar.Collapse id="navbarSupportedContent" className="w-100">
                            {/* Mobile header content */}
                            <Container fluid className="px-2 px-md-3">
                                <div className="d-lg-none w-100 mb-3 mt-2">
                                    {gstrHeaderAllowedTypes.includes(type) ? <GstrHeader headerTitle={headerTitle} type={type} /> : <MainHeader headerTitle={headerTitle} />}
                                </div>

                                <Nav as="ul" className="ml-auto align-items-center navbar-list w-100 justify-content-end">
                                    {/* Profile */}
                                    <div className="d-flex justify-content-center">
                                        <Dropdown as="li" className="nav-icon nav-item caption-content" show={showProfileDropdown} onToggle={handleProfileToggle}>

                                            <Dropdown.Toggle as="a" className="search-toggle mb-2">
                                                <div className="caption bg-primary line-height cursor-pointer">
                                                    {userData?.name && userData?.name.trim() != '' ? userData.name[0] : 'Z'}
                                                </div>
                                            </Dropdown.Toggle>


                                            <Dropdown.Menu className="dropdown-menu iq-sub-dropdown" align="end" style={{ minWidth: '280px' }}>

                                                <Card className="mb-0">
                                                    <Card.Header className="d-flex justify-content-between align-items-center mb-0">
                                                        <div className="header-title">
                                                            <h4 className="card-title mb-0">Profile</h4>
                                                        </div>
                                                        <Badge pill bg="primary" className="cursor-pointer close-data text-right" onClick={() => setShowProfileDropdown(false)}>
                                                            <i className="ri-close-fill"></i>
                                                        </Badge>
                                                    </Card.Header>


                                                    <Card.Body className="p-3">

                                                        <div className="profile-header">
                                                            <div className="cover-container text-center">
                                                                <div className="rounded-circle profile-icon bg-primary mx-auto d-block">
                                                                    {userData?.name && userData?.name.trim() != '' ? userData.name[0] : 'Z'}
                                                                </div>
                                                                <div className="profile-detail mt-3">
                                                                    <h5><Link to="/manage-profile" className="text-decoration-none">{userData?.name && userData?.name.trim() != '' ? userData.name : 'Noname'}</Link></h5>
                                                                    <p className="mb-2 small text-muted">{userData?.email && userData?.email.trim() != '' && userData.email}</p>
                                                                </div>
                                                                <div className="mt-3 d-grid gap-2">
                                                                    <Button variant="link" size="sm" onClick={() => setShowResetPasswordModal(true)}>Update Password</Button>
                                                                    <Button size="sm" onClick={handleSignOut}>Sign Out</Button>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </Nav>
                            </Container>
                        </Navbar.Collapse>
                    </Navbar>
                </div>
            </div>
            <ResetPasswordModal showModal={showResetPasswordModal} handleModalClose={handleResetPasswordModalClose} />
        </>
    );
};

export default Header;